import './lastPage.css'
import React from 'react';
import tata from '../pictures/Image 579.png'
export default function LastPage() {
    return (
        <div className="wholePage">
            <div className="ABOUT_THE_PARTNERS">ABOUT THE PARTNERS</div>
            <div className="elevated"><p>Elevated by <br />Nothing But The Best</p></div>
            <div className="lasttxt"><p>A leading real estate player in India,
            Conscient has so far delivered over 11,000 homes across Delhi-NCR, Dehradun & Goa in the last
            4 decades. Based in USA, Hines is a privately-owned global real estate investment, development
            and management firm, founded in 1957, with a presence in 214 cities across 24 countries and $120.6
                billion of assets under management.<br /><br /> Tata Projects, renowned as India’s fastest growing and most
                admired infrastructure company, has rich expertise in executing complex urban construction projects.
                <br /><br />The two industry stalwarts, Hines and Conscient, with Tata Projects appointed as a construction partner,
                  have together joined hands to create their first residential landmark in India and raise the bar of Gurugram’s
                   lifestyle with Elevate.</p></div>
            <div className="sideline"></div>
            <div className="developer">Developer</div>
            <div className="symbol2">
                <div className="accent2">Accent</div>
                <div className="build3">Buidtech Pvt Ltd.</div>
            </div>
            <div className="investment_manager">INVESTMENT MANAGER</div>
            <div className="himes"></div>
            <div className="investment_manager1">INVESTMENT MANAGER</div>
            <div className="tata">
                <img src={tata} alt="" />
            </div>
            <div className="footer">© 2020 TASHREEN REALTECH PVT. LTD. All Rights Reserved | Privacy Policy</div>
        </div>
    );
}